export const modularHousesNavItems = {
  model: '3D Model',

  options: 'Options',

};


export const description = 'Modular houses offer unusual design and comfortable living for your family. Cozy Cáceres, romantic Toledo or dynamic Barcelona - this type of accommodation fits easily into any landscape. We produce modern, energy efficient and prefabricated modular buildings. Your home, completely ready for permanent residence, will take into account all your needs. You are given the opportunity to choose the option with a turnkey interior finish.'